export default "__VITE_ASSET__CTuRfRRf__"